/* eslint-disable @typescript-eslint/no-explicit-any */
import { generateId } from "./utils";
// eslint-disable-next-line
const traceLog = (...args) => {
    if (Array.isArray(args) &&
        typeof args[0] === "string" &&
        args[0].includes("------") // use '------' to turn off the tracing
    ) {
        // eslint-disable-next-line
        console.groupCollapsed(...args);
        // eslint-disable-next-line
        console.trace();
        // eslint-disable-next-line
        console.groupEnd();
    }
};
const promisify = (func) => {
    return (_observer) => Promise.resolve().then(() => func(_observer));
};
const _notify = (args) => (observer) => {
    return observer(args);
};
/**
 * An event topic that {@link Observer Observers} can listen to for new events.
 *
 * Anything that has access to a Subject instance can publish events using
 * {@link notify} and/or subscribe to a subject using {@link attach}.
 *
 * @template A The type for the payload observers are notified with
 *
 * @see {@link Subject.attach} Subscribe to the subject and listen for new
 * events
 * @see {@link Subject.notify} Publish a new event, notifying all subscribers
 */
class Subject {
    constructor(name) {
        this.observers = [];
        this.name = generateId(`${name ? name : "subject"}-`);
        traceLog(`[${this.name}]: constructed`, this);
    }
    /**
     * Subscribe an {@link Observer} to this {@link Subject}.
     *
     * @param observer The {@link Observer} subscribing
     *
     * @returns A function that, when called, {@link Subject.detach detaches}
     * `observer` from this {@link Subject}.
     */
    attach(observer) {
        this.observers.push(observer);
        traceLog(`[${this.name}]: attached an observer`, this);
        return () => this.detach(observer);
    }
    /**
     * Unsubscribe an {@link Observer} from this subject. After calling this method,
     * the observer will no longer receive published events. This is a no-op if
     * `observer` never {@link Subject.attach attached}.
     *
     * @param observer The {@link Observer} to unsubscribe.
     */
    detach(observer) {
        traceLog(`[${this.name}]: detached an observer`, this);
        this.observers = this.observers.filter(o => o !== observer);
    }
    /**
     * Asynchronously Publishes an event to all {@link Observer Observers}
     * subscribed to this {@link Subject}.
     *
     * @param args A payload to pass to each {@link Observer}.
     *
     * @returns a Promise that resolves when all {@link Observer Observers} have
     * been notified.
     */
    notifyAsync(args) {
        return Promise.all(this.observers.map(promisify(_notify(args)))).then();
    }
    /**
     * Publishes an event to all {@link Observer Observers} subscribed to this
     * {@link Subject}.
     *
     * @param args A payload to pass to each {@link Observer}.
     */
    notify(args) {
        traceLog(`[${this.name}]: notifying observers`);
        this.observers.forEach(_notify(args));
    }
}
export default Subject;
//# sourceMappingURL=event-observer.js.map